import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import {
  ButtonGroup,
  CompanyLogo,
  MainMenuDropdown,
  MenuItem,
} from 'components/HomePage/Header/index'
import {
  orgFeatures,
  personalFeatures,
  helpLinks,
  solutions,
  industries,
} from 'components/HomePage/Header/menus'
import VerticalDivider from 'ui/VerticalDivider'
import { OrgAndPersonalHeaderButtons } from 'components/NewStaticPage/StaticPageHeader'
import useDetermineTypeOfHeader from 'utils/useDetermineTypeOfHeader'
import { useAppSelector } from 'store/hooks'
import { userApi } from 'store/api/user'
import { BLOG_CONTROL_D_DOMAIN } from 'gatsby-env-variables'
import { freeTools } from './menus/freeTools'
import { FreeToolsDropdown } from './HomepageDropdowns/FreeToolsDropdown'
import { OrgAndPersonalDropdown } from './OrgAndPersonDropdown'

export function DesktopHeader(): ReactElement {
  const { isPersonalHeader } = useDetermineTypeOfHeader()
  const sessionToken = useAppSelector(s => s.session.sessionToken)
  const { data: userData, isLoading: isUserDataLoading } =
    userApi.endpoints.getUser.useQueryState('')
  const isOrgLoggedIn = userData?.org

  return (
    <>
      <Flex
        sx={{
          flexShrink: 0,
          gap: '2.4rem',
          alignItems: 'center',
          '@media screen and (max-width: 1420px)': {
            gap: '0.8rem',
          },
        }}
      >
        <Flex>
          <CompanyLogo
            sx={{
              '@media screen and (max-width: 1350px)': {
                display: 'none',
              },
            }}
          />
        </Flex>
        <OrgAndPersonalButtonsOrDropdown />
      </Flex>
      <Flex>
        <Flex sx={{ justifyContent: 'space-between', flexShrink: 0 }}>
          {!isUserDataLoading && (
            <Flex
              sx={{
                alignItems: 'center',
                flexShrink: 0,
                p: 0,
                pr: sessionToken ? '0.8rem' : 0,
              }}
            >
              <MainMenuDropdown
                testId="features-dropdown"
                dropdownItems={isPersonalHeader ? personalFeatures : orgFeatures}
              >
                Features
              </MainMenuDropdown>
              {!isPersonalHeader && (
                <MainMenuDropdown testId="industries-dropdown" dropdownItems={industries}>
                  Industries
                </MainMenuDropdown>
              )}
              {!isPersonalHeader && (
                <MainMenuDropdown testId="solutions-dropdown" dropdownItems={solutions}>
                  Solutions
                </MainMenuDropdown>
              )}
              {!isOrgLoggedIn && (
                <MenuItem text="Pricing" to={isPersonalHeader ? '/plans' : '/pricing'} />
              )}
              <FreeToolsDropdown testId="free-tools-dropdown" dropdownItems={freeTools}>
                Free Tools
              </FreeToolsDropdown>
              <MainMenuDropdown testId="help-dropdown" dropdownItems={helpLinks}>
                Help
              </MainMenuDropdown>
              <MenuItem text="Blog" to={`${BLOG_CONTROL_D_DOMAIN}`} />
            </Flex>
          )}
          {!sessionToken && (
            <VerticalDivider
              sx={{
                height: '4rem',
                backgroundColor: 'borderLight',
                flexShrink: 0,
                mx: '0.8rem',
              }}
            />
          )}
        </Flex>
        <ButtonGroup />
      </Flex>
    </>
  )
}

function OrgAndPersonalButtonsOrDropdown() {
  const sessionToken = useAppSelector(s => s.session.sessionToken)

  return (
    <>
      <Flex
        sx={{
          display: 'none',
          [`@media screen and (min-width: 1120px) and (max-width: ${
            sessionToken ? '1380px' : '1480px'
          })`]: {
            display: 'flex',
          },
        }}
      >
        <OrgAndPersonalDropdown />
      </Flex>
      <Flex
        sx={{
          display: 'flex',
          [`@media screen and (min-width: 1120px) and (max-width: ${
            sessionToken ? '1380px' : '1480px'
          })`]: {
            display: 'none',
          },
        }}
      >
        <OrgAndPersonalHeaderButtons />
      </Flex>
    </>
  )
}
